<template>
<div>
    <v-slide-x-reverse-transition>
        <v-alert type="success" class="alert_success" v-if="alert_show_add === true">เพิ่มแหล่งที่มาเรียบร้อย</v-alert>
        <v-alert type="success" class="alert_success" v-if="alert_show_edit === true">แก้ไขแหล่งที่มาเรียบร้อย</v-alert>
    </v-slide-x-reverse-transition>
    <div v-if="loading_page === true">
        <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
            <v-skeleton-loader type="article, actions"></v-skeleton-loader>
        </v-sheet>
    </div>
    <div v-if="loading_page === false">
        <div class="d-flex justify-space-between card_stock_source_list">
            <div class="mr-1">
                <v-form ref="form" @submit.prevent="addStockSource()">
                    <div class="mb-2">
                        <h3>{{ edit_id !== null ? 'แก้ไข' : 'เพิ่ม'}}แหล่งที่มา</h3>
                    </div>
                    <v-text-field label="ชื่อแหล่งที่มา" v-model="name" :rules="[v => !!v || 'กรุณากรอกชื่อแหล่งที่มา']" required outlined></v-text-field>
                    <v-text-field label="เบอร์โทรติดต่อ" v-model="tel" type="tel" maxlength="11" @keypress="isNumber($event)" onpaste="return false" outlined></v-text-field>
                    <v-textarea outlined label="รายละเอียด" v-model="note"></v-textarea>
                    <v-btn color="#038cc1" class="titlefont_stock_source_list white--text" width="100%" height="50" type="submit">
                        บันทึก
                    </v-btn>
                </v-form>
            </div>
            <div class="ml-1">
                <v-card>
                    <v-card-title>
                        <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
                    </v-card-title>
                    <v-data-table :headers="headers" :items="data" :search="search">
                        <template v-slot:item="dataDetail">
                            <tr>
                                <td>{{ dataDetail.item.number }}</td>
                                <td>{{ dataDetail.item.name }}</td>
                                <td>{{ dataDetail.item.tel }}</td>
                                <td>{{ dataDetail.item.note }}</td>
                                <td>
                                    <span class="edit_data_stock_source_list" @click="detailStockSource(dataDetail.item.id)">
                                        <v-icon dark right color="grey">mdi-pencil-box-outline</v-icon>
                                    </span>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-card>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import stocksource from '@/api/stock/stocksetting/stocksource.js'
export default {
    inject: {
        theme: {
            default: {
                isDark: false
            },
        },
    },
    data() {
        return {
            loading_page: true,
            alert_show_add: false,
            alert_show_edit: false,
            search: '',
            headers: [{
                    text: '#',
                    align: 'start',
                    value: 'number',
                },

                {
                    text: 'แหล่งที่มา',
                    value: 'name'
                },
                {
                    text: 'เบอร์โทร',
                    value: 'tel'
                },
                {
                    text: 'Note',
                    value: 'note'
                },
                {
                    text: 'แก้ไข',
                    value: 'action'
                },
            ],
            data: [],
            edit_id: null,
            name: null,
            tel: null,
            note: null,
        }
    },
    methods: {
        async stockSourceList() {
            this.loading_page = true
            this.data = []
            stocksource.sourceList().then((response) => {
                if (response.data.successful === true) {
                    this.data = response.data.sourceList
                    response.data.sourceList.forEach((detail, index) => {
                        this.data[index]['number'] = index + 1
                    })
                    this.loading_page = false
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
        },
        async detailStockSource(id) {
            stocksource.detailSource(id).then((response) => {
                if (response.data.successful === true) {
                    this.edit_id = response.data.sourceDetail.id
                    this.name = response.data.sourceDetail.name
                    this.tel = response.data.sourceDetail.tel
                    this.note = response.data.sourceDetail.note
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
        },
        async isNumber(evt) {
            evt = (evt) ? evt : window.event;
            let charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 45) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        async addStockSource() {
            if (this.$refs.form.validate()) {
                this.loading_page = true
                const data = {
                    source_name: this.name,
                    source_tel: this.tel,
                    source_note: this.note,
                }
                if (!this.edit_id) {
                    stocksource.addSource(data).then((response) => {
                        if (response.data.successful === true) {
                            this.edit_id = null
                            this.name = null
                            this.tel = null
                            this.note = null
                            this.stockSourceList()
                            this.alert_show_add = true
                            setTimeout(() => this.alert_show_add = false, 5000)
                        }
                    }).catch((error) => {
                        if (error.response.status === 401) {
                            this.$store.commit('logOutSuccess')
                            this.$router.push('/login')
                        }
                    })
                }
                if (this.edit_id) {
                    stocksource.editSource(this.edit_id, data).then((response) => {
                        if (response.data.successful === true) {
                            this.edit_id = null
                            this.name = null
                            this.tel = null
                            this.note = null
                            this.stockSourceList()
                            this.alert_show_edit = true
                            setTimeout(() => this.alert_show_edit = false, 5000)
                        }
                    }).catch((error) => {
                        if (error.response.status === 401) {
                            this.$store.commit('logOutSuccess')
                            this.$router.push('/login')
                        }
                    })
                }

            }
        }
    },
    mounted() {
        this.stockSourceList()
    }
}
</script>

<style scoped>
.card_stock_source_list>div:first-child {
    width: 30%;

}

.card_stock_source_list>div:last-child {
    width: 70%;
}

.titlefont_stock_source_list {
    font-size: 22px !important;
}

.edit_data_stock_source_list {
    cursor: pointer;
}
</style>
